export const templateListFindings = (rows = [], { actions = {} } = {}) =>
  (Array.isArray(rows) ? rows : [])
    .filter(t => t.sentCount >= 50 && (t.replyCount || 0) / t.sentCount < 0.02)
    .slice(0, 2)
    .map(t => ({
      tone: "warn",
      label: `${t.name} gets ${Math.round(((t.replyCount || 0) / t.sentCount) * 100)}% replies`,
      text: "Under 2% with real volume. Rewrite the opener.",
      actions: actions.rewrite ? [{ label: "Rewrite with copilot", run: () => actions.rewrite(t) }] : []
    }));

export const templateDetailFindings = ({ body = "", actions = {} } = {}) => {
  if (!body) return [];
  const out = [];
  if (!/\{\{\s*unsubscribe/i.test(body)) {
    out.push({
      tone: "bad",
      key: "no_unsubscribe",
      label: "No unsubscribe link",
      text: "Cold email without one is a compliance and deliverability risk. Add {{unsubscribeLink}}.",
      actions: actions.edit ? [{ label: "Edit template", run: actions.edit }] : []
    });
  }
  const links = (body.match(/href=/gi) || []).length;
  if (links > 3) {
    out.push({
      tone: "warn",
      key: "too_many_links",
      label: `${links} links`,
      text: "More than three links reads as a newsletter to spam filters. Keep one.",
      actions: actions.rewrite ? [{ label: "Rewrite with copilot", run: actions.rewrite }] : []
    });
  }
  const words = body.replace(/<[^>]+>/g, " ").trim().split(/\s+/).filter(Boolean).length;
  if (words > 200) {
    out.push({
      tone: "neutral",
      key: "too_long",
      label: `${words} words`,
      text: "Cold email that gets replies is under 120 words. Cut it in half.",
      actions: actions.rewrite ? [{ label: "Rewrite with copilot", run: actions.rewrite }] : []
    });
  }
  return out;
};
